import { STATUS } from '@features/General'
import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface IEventReportPayload {
    participants?: any
    companies?: any
    meetingDate?: string
    status?: string[]
    meetingType?: string[]
    sagaCB: {
        onSuccess: any
    }
}

export interface IState {
    status: string
    data: any
    errors: any
}

const initialState: IState = {
    status: STATUS.IDLE,
    data: null,
    errors: null
}

const eventReportSlice = createSlice({
    name: 'reporting/event-report',
    initialState,
    reducers: {
        onRequest(state, action: PayloadAction<IEventReportPayload>) {
            state.status = STATUS.RUNNING
        },
        onSuccess(state, action) {
            state.status = STATUS.READY
            state.data = action.payload
        },
        onFailure(state, action) {
            state.status = STATUS.ERROR
            state.errors = action.payload
        }
    }
})

export const eventReportActions = eventReportSlice.actions
export default eventReportSlice.reducer
